<template>
    <div class="view-tasklists courselists">
        <user-menu />
        <div class="wrapper">
            <masteradmin-sidebar-menu />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Courses</h3>
            <button
                v-on:click="isAddCourseModalVisible = true, verrors.clear(), image = ''"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>External Course</button>
                       
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    
          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down   "></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              class="col-lg-4 col-md-12 col-12"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Course Title"
              @keyup.enter="filterCourseitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-3 col-md-12 col-12 padding-lr-5">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterCourseitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-4 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_affiliate"
                :options="affiliate_options_search"
                @change="filterCourseitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterCourseitems()">
            <span class="search-icon">
              <i class="fa fa-search"></i>
            </span>
            </div>
          </div>
          </div>
          </b-collapse>
        </b-navbar>
      </div>
          <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body>
                            <div class="row tasks_heading_row">
                                <div class="bold cursor-pointer  col-2">
                                    Course Title                       
                                </div>
                                <div class="bold cursor-pointer  col-1 override-padding">
                                    Course ID
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    # of Modules
                                </div>
                                <div class="bold cursor-pointer col-2 override-padding">
                                     # of Final Exam Q's
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    Last Updated
                                </div>
                                <div class="bold cursor-pointer col-2 override-padding">
                                    Last Updated By 
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    # of Affiliates
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    Access
                                </div>
                                <div class="bold cursor-pointer col-1 override-padding">
                                    
                                </div>
                            </div>
                            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                            <b-card-text v-if="course_lists.length > 0">
                                <div v-for="(courseinfo, index) in course_lists" class="tasklist-row">
                                    <div class="row tasklist-item"  style="margin: 0;">
                                        <div class="col-2 package-name">{{courseinfo.course_name}}</div>
                                         <div class="col-1 override-padding">{{courseinfo.course_id}}</div>
                                        <div class="col-1 override-padding">{{courseinfo.module_count}}</div>
                                        <div class="col-2 override-padding">{{courseinfo.questions_count}}</div>
                                        <div class="col-1 override-padding">{{courseinfo.updated_time}}</div>
                                        <div class="col-2 override-padding">{{courseinfo.updated_by}}</div>                       
                                        <div class="col-1 override-padding">{{courseinfo.no_of_affiliates}}</div>
                                        <div class="col-1 override-padding cursor-pointer bold" v-if="courseinfo.course_id == 'External Course'">
                                           <a  @click="getExternalCourseDetails(courseinfo.id)" id="manage-link">Edit</a>
                                        </div>
                                        <div class="col-1 override-padding cursor-pointer bold" v-else>
                                           <a  @click="manageCourse(courseinfo.course_id, courseinfo.course_name)" id="manage-link">Manage</a>
                                        </div>
                                        <div class="col-1 override-padding" v-if="courseinfo.course_id == 'External Course'">
                                            <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                                            <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                                              <li></li>
                                              <li></li>
                                              <li></li>
                                            </ul>
                                            <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                                              <div class="action-dd-menu" v-if="(courseinfo.status=='DRAFT')" @click="updateCourseStatus(courseinfo.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                                              <div class="action-dd-menu"  v-if="((courseinfo.status=='DRAFT' || courseinfo.status=='DEACTIVATED'))" @click="deleteCourseConfirm(courseinfo.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                                              <div class="action-dd-menu" v-if="(courseinfo.status=='PUBLISH')" @click="deactivateCourseConfirm(courseinfo.id, courseinfo.course_name)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                                            </div>
                                            </div>
                                            
                                        </div>
                                        <div class="col-1 override-padding" v-else>
                                            <div v-bind:id="'dropdown-container'+ index" class="dropdown">
                                            <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                                              <li></li>
                                              <li></li>
                                              <li></li>
                                            </ul>
                                            <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                                            </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div><hr></div>
                                </div>
                                
                            </b-card-text>
                            <b-card-text v-else-if="loading == false">
                                    No Courses found.
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                
    <ManageCourseModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>

      <div slot="header">
       <div class="sub-heading"><h3 style="font-size: 14px;">Course: {{courseTitle}}</h3></div>
      </div> 
      
      <div slot="body" v-if="isModalVisible == true">

        

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="text" label="text"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate[]"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">Affiliates ({{ values.length }} selected)</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
  
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">Users ({{ values.length }} selected)</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>

          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="saveCourseAffiliates()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Save</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ManageCourseModal>



      <CreateCourseModal :isModalVisible="isAddCourseModalVisible" @close="isAddCourseModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="color: #00"><h3>Add External Course</h3></div>
        <div slot="body"  v-if="isAddCourseModalVisible == true">
          <div class="col-12 override-padding">
            <input v-model="course_name"
                  name="course_name"
                  placeholder="Enter External Course Name"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('course_name', 'required')" class="margin-bottom-5 validate-warning-msg">External Course Name is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="course_organization"
                  name="course_organization"
                  placeholder="Course Organization"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('course_organization', 'required')" class="margin-bottom-5 validate-warning-msg">Course Organization is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" style="display:flex;">
            <div 
              class="search-padd" 
              id="affliate-wrapper" 
              style="height: 30px;width: 100%;">
              <multiselect v-model="affiliate"
                :options="affiliate_options"
                track-by="value"
                label="text"
                placeholder="Select Affiliate"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'extaffiliate[]'"
                v-bind:id="'extaffiliate'"
                v-validate="'required'">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
            </div>
          </div>
          <div v-if="verrors.firstByRule('extaffiliate[]', 'required')" class="validate-warning-msg" style="margin-top: 15px;">Affiliate is required</div>
          <div v-else class="validate-warning-msg" style="margin-top: -5px;">&nbsp;</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="course_link"
                  name="course_link"
                  placeholder="External Course Link or Registration Link"
                  class="col-lg-12 input-height-25 input-class"
                  maxlength="255" />
            <div v-if="verrors.has('course_link')" class="margin-bottom-5 validate-warning-msg">Link is invalid</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>

          <div class="col-12 override-padding">
            <input 
              @change="handleImage"
              type="file" 
              name="image_file"
              ref="image_file"
              v-validate="'required'"
              accept="image/*"
              rules="required"
              class="input-file"  >
            <div v-if="verrors.firstByRule('image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Logo is required</div>
            <div class="help-text">Logo should be jpg, jpeg, gif, png and size should be of 2MB</div>
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-9 float-left p-0 text-center" style="border: 1px solid #707070; height: 100px; width: 250px;" v-if="image">
              <img :src="image" width="100" height="85" style=" padding-top: 10px;" />
            </div>
            <div class="col-9 float-left p-0" style="border: 1px solid #707070; height: 100px; width: 250px; text-align: center; padding-top: 35px !important;"  v-else>
              Logo Example
            </div>
            <div class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 35px;">
              <button
                  v-on:click="createCourse()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Create</b></button>
              <button
                  v-on:click="uploadcsvAction()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn mt-2"
                  ><b>Upload CSV</b></button>

            </div>            
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CreateCourseModal>


      <EditCourseModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Edit External Course</h3></div>
        <div slot="body" v-if="isEditModalVisible == true">
          <div class="col-12 override-padding">
            <input v-model="edit_course_name"
                  name="edit_course_name"
                  placeholder="Enter External Course Name"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_course_name', 'required')" class="margin-bottom-5 validate-warning-msg">External Course Name is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="edit_course_organization"
                  name="edit_course_organization"
                  placeholder="Course Organization"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_course_organization', 'required')" class="margin-bottom-5 validate-warning-msg">Course Organization is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" style="display:flex;">
            <div 
              class="search-padd" 
              id="affliate-wrapper" 
              style="height: 30px;width: 100%;">
              <multiselect v-model="edit_affiliate"
                :options="affiliate_options"
                track-by="value"
                label="text"
                placeholder="Select Affiliate"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'edit_affiliate[]'"
                v-bind:id="'affiliate'"
                v-validate="'required'">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
            </div>
          </div>
          <div v-if="verrors.firstByRule('edit_affiliate[]', 'required')" class="validate-warning-msg" style="margin-top: 15px;">Affiliate is required</div>
          <div v-else class="validate-warning-msg" style="margin-top: -5px;">&nbsp;</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="edit_course_link"
                  name="edit_course_link"
                  placeholder="Course Link or Registration Link"
                  class="col-lg-12 input-height-25 input-class"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_course_link')" class="margin-bottom-5 validate-warning-msg">Link is invalid</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>

          <div class="col-12 override-padding" v-if="(edit_image_flag == 1)">
            <input 
              @change="handleEditImage"
              type="file" 
              name="edit_image_file"
              ref="edit_image_file"
              v-validate="'required'"
              accept="image/*"
              rules="required"
              class="input-file" >
            <div v-if="verrors.firstByRule('edit_image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Logo is required</div>
            <div class="help-text" >Logo should be jpg, jpeg, gif, png and size should be of 2MB</div>
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div class="col-12 override-padding" v-else>
            <button
              v-on:click="RemoveImage()"
              class="btn btn-red btn-md input-height-15 col-4"
              style="height: 30px;"
              ><b>Remove Image</b></button>
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-9 float-left p-0 text-center" style="border: 1px solid #707070; height: 100px; width: 250px;" v-if="edit_image">
              <img :src="edit_image" width="100" height="85" style=" padding-top: 10px;" />
            </div>
            <div class="col-9 float-left p-0" style="border: 1px solid #707070; height: 100px; width: 250px; text-align: center; padding-top: 35px !important;"  v-else>
              Logo Example
            </div>
            <div class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 60px;">
              <button
                  v-on:click="editCourse()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Save</b></button>

            </div>            
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </EditCourseModal>




      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to delete the course?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteCourse(id)">Confirm</button>
        </div>
      </DeleteModal>

      <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to deactivate the course? </div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateCourse(deactivateId)">Confirm</button>
        </div>
      </DeactivateModal>




      <UploadExternalCourseModal :isModalVisible="isUploadExternalCourseModalVisible" @close="isUploadExternalCourseModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="color: #00"><h3>Upload External Course</h3></div>
        <div slot="body"  v-if="isUploadExternalCourseModalVisible == true">
          <div class="col-lg-4 p-0" style="font-weight: bold;">
            Upload CSV:
          </div>
          <div class="col-12 override-padding">
            <div class="dropbox" v-if="isInitial || isSaving">
              <input 
                type="file" 
                name="account_csv" 
                :disabled="isSaving" 
                accept="type/csv"
                rules="required"
                @change="filesChange($event.target.name, $event.target.files)"
                class="input-file">
                <!-- <div v-if="verrors.firstByRule('ext_field', 'ext:jpeg,jpg')" class="margin-bottom-5 validate-warning-msg">File should be CSv</div> -->
                <p v-if="isInitial">Drag your file(s) here to begin<br> or click to browse</p>
                <p v-if="isSaving"> Uploading file... </p>
            </div>
            <p v-if="uploadError" class="text-danger">{{uploadError}}</p>

          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input 
              @change="handleUploadECImage"
              type="file" 
              name="uploadcsv_image_file"
              ref="uploadcsv_image_file"
              v-validate="'required'"
              accept="image/*"
              rules="required"
              class="input-file"  >
            <div v-if="verrors.firstByRule('uploadcsv_image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Logo is required</div>
            <div class="help-text">Logo should be jpg, jpeg, gif, png and size should be of 2MB</div>
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-9 float-left p-0 text-center" style="border: 1px solid #707070; height: 100px; width: 250px;" v-if="uploadECImage">
              <img :src="uploadECImage" width="100" height="85" style=" padding-top: 10px;" />
            </div>
            <div class="col-9 float-left p-0" style="border: 1px solid #707070; height: 100px; width: 250px; text-align: center; padding-top: 35px !important;"  v-else>
              Logo Example
            </div>
            <div v-if="showWait == false" class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 71px;">
              <button
                  v-on:click="saveUpload()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Upload</b></button>

            </div>            
            <div v-if="showWait == true" class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 71px;">
              <button
                  disabled="true"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Upload</b></button>

            </div>            
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </UploadExternalCourseModal>


            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import ManageCourseModal from './manage_course_modal.vue';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import Multiselect from 'vue-multiselect';
import CreateCourseModal from '../admin/create-tasklist-modal.vue';
import UploadExternalCourseModal from '../admin/create-tasklist-modal.vue';
import EditCourseModal from '../admin/create-tasklist-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
    data() {
        return {            
            loading: false,            
            isModalVisible: false,
            course_lists: [],          
            affiliate_options: [],
            search_status: '',
            status_options: [
              { value: '', text: 'Select Course Type' },
              { value: 'Internal', text: 'Internal Course' },
              { value: 'External', text: 'External Course' },
            ],
            search_affiliate: '',
            search_keyword: '',
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            course_selected: '',
            courseTitle: '',
            course_name: '',
            course_organization: '',
            course_link: '',
            affiliate: [],
            image: '',
            isAddCourseModalVisible: false,
            id: '',
            deactivateId: '',
            activateId: '',
            isDeleteModalVisible: false,
            isDeactivateModalVisible: false,
            isDeactivateValidateModalVisible: false,
            isActivateModalVisible: false,
            isEditModalVisible: false,
            edit_course_name: '',
            edit_course_organization: '',
            edit_course_link: '',
            edit_affiliate: [],
            edit_image: '',
            edit_image_flag: 0,
            affiliate_options_search: [],
            isUploadExternalCourseModalVisible: false,
            uploadECImage: '',
            uploadedFiles: [],
            uploadError: '',
            currentStatus: null,
            parse_csv: [],
            csvDataObj: {},
            uploadCSVFlag: 0,
            showWait: false,

        }
    },
    components: {
        UserMenu,
        ManageCourseModal,
        MasteradminSidebarMenu,
        Multiselect,
        CreateCourseModal,
        EditCourseModal,
        DeleteModal,
        DeactivateModal,
        ActivateModal,
        UploadExternalCourseModal,
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
        uploadcsvAction() {
          this.isUploadExternalCourseModalVisible = true;
          this.uploadECImage = '';
          this.isAddCourseModalVisible = false;
          this.currentStatus = STATUS_INITIAL;
          this.uploadError = '';
          this.uploadCSVFlag = 0;
        },
        filesChange(fieldName, fileList) {
          // handle file changes
          this.uploadError = '';
          const csvData = new FormData();
          if (!fileList.length) return;
          if(fileList[0].type !== "text/csv") {
            this.uploadError = 'Upload CSV file only'
            return
          }
          // append the files to FormData
          csvData.append(fieldName, fileList[0], fileList[0].name)
          this.currentStatus = STATUS_SAVING;
          this.csvDataObj = csvData;
          this.uploadCSVFlag = 1;
        },
        doUploadCSVValidate: function() {
          var vflag = 1;
          if(this.uploadCSVFlag == 0) {
            alert("Please upload CSV");
            vflag = 0;
            return false;
          }
          if(this.uploadECImage == '') {
            alert("Please upload Image");
            vflag = 0;
            return false;
          }
          else {
            if((this.$refs.uploadcsv_image_file.files[0].type != 'image/jpeg') && (this.$refs.uploadcsv_image_file.files[0].type != 'image/jpg') && (this.$refs.uploadcsv_image_file.files[0].type != 'image/png') && (this.$refs.uploadcsv_image_file.files[0].type != 'image/gif')) {
              alert("Image should be of jpeg, jpg, png, gif formats only");
              vflag = 0;
              return false;
            }
            else if(this.$refs.uploadcsv_image_file.files[0].size > 2000000) {
              alert("Image size should be of 2 MB only");
              vflag = 0;
              return false;
            }
          }
          return vflag;
        },
        saveUpload() {
          var vflag = this.doUploadCSVValidate();
          // upload data to the server
          if(vflag == 1) {
            this.showWait = true;
            this.currentStatus = STATUS_SAVING;
            const fileData = this.csvDataObj;
            fileData.append("image", this.uploadECImage);
            axios.post('/import/external-course-upload', fileData, {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Accept': 'text/csv',
                  'Content-Type': 'multipart/form-data'
                },
            })
            .then(resp => {
              this.showWait = false;
              this.isUploadExternalCourseModalVisible = false;
              this.fetchCourseListitems();
              this.uploadCSVFlag = 0;
              this.uploadError = '';
              alert('External course uploaded successfully');
              this.currentStatus = STATUS_SUCCESS;
            })
            .catch(error => {
              this.uploadError = error.response.data.message;
              this.currentStatus = STATUS_FAILED;
            })
          }
        },
        closeModal() {
            this.$emit('close');
        },       
        RemoveImage() {
          this.edit_image_file = '';
          this.edit_image = '';
          this.edit_image_flag = 1;
        },
        handleUploadECImage(e) {
          var selectedImage = e.target.files[0];
          this.createUploadECBase64Image(selectedImage);
        },
        createUploadECBase64Image(fileObject){
          const reader = new FileReader();
          reader.onload = (e) => {
            this.uploadECImage = e.target.result;
          };
          reader.readAsDataURL(fileObject);
        },
        handleImage(e) {
          var selectedImage = e.target.files[0];
          this.createBase64Image(selectedImage);
        },
        handleEditImage(e) {
          var selectedImage = e.target.files[0];
          this.createEditBase64Image(selectedImage);
          this.edit_image_flag = 1;
        },
        createBase64Image(fileObject){
          const reader = new FileReader();
          reader.onload = (e) => {
            this.image = e.target.result;
          };
          reader.readAsDataURL(fileObject);
        },
        createEditBase64Image(fileObject){
          const reader = new FileReader();
          reader.onload = (e) => {
            this.edit_image = e.target.result;
          };
          reader.readAsDataURL(fileObject);
        },
            filterCourseitems() {
               this.filterFlag = true;
               this.fetchCourseListitems();
            },

            getExternalCourseDetails(courseId) {
              axios.get('/get-external-course-details/' + courseId)
              .then((resp) => {
                this.courseId = courseId;
                this.isEditModalVisible = true;
                this.edit_course_name = resp.data.cert.course_name;
                this.edit_course_organization = resp.data.cert.course_organization;
                this.edit_course_link = resp.data.cert.course_link;
                this.edit_affiliate = resp.data.cert.affiliate;
                this.edit_image = resp.data.cert.certification_logo;
                this.edit_image_file = '';
                this.edit_image_flag = 0;
              })
              .catch(error => {

              });

            },


            doEditValidate: function() {
              var vflag = 1;
              if(this.edit_course_link != '') {
                if(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm.test(this.edit_course_link)) {
                  
                }
                else {
                  alert("Please enter a valid certification link");
                  vflag = 0;
                  return false;
                }
              }
              if(this.edit_image == '') {
                alert("Please upload Image");
                vflag = 0;
                return false;
              }
              else {
                if(this.edit_image_flag == 1) {
                  if((this.$refs.edit_image_file.files[0].type != 'image/jpeg') && (this.$refs.edit_image_file.files[0].type != 'image/jpg') && (this.$refs.edit_image_file.files[0].type != 'image/png') && (this.$refs.edit_image_file.files[0].type != 'image/gif')) {
                    alert("Image should be of jpeg, jpg, png, gif formats only");
                    vflag = 0;
                    return false;
                  }
                  else if(this.$refs.edit_image_file.files[0].size > 2000000) {
                    alert("Image size should be of 2 MB only");
                    vflag = 0;
                    return false;
                  }
                }
              }
              return vflag;
            },
            editCourse() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                var vflag = this.doEditValidate();
                if(vflag == 1) {
                  axios('/external-courses/' + this.courseId,
                     {
                       method: 'PATCH',
                       data:
                        {
                          course_name: this.edit_course_name,
                          course_organization: this.edit_course_organization,
                          link: this.edit_course_link,
                          affiliate_selected: this.edit_affiliate,
                          image: this.edit_image,
                        },
                     }
                   )
                  .then((resp) => {
                      this.edit_course_name = '';
                      this.edit_course_organization = '';
                      this.edit_course_link = '';
                      this.edit_image = '';
                      this.edit_affiliate = [];
                      this.isEditModalVisible = false;
                      this.fetchCourseListitems();
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

                }
                }
              })
              .catch(() => {

              });
            },


            doValidate: function() {
              var vflag = 1;
              if(this.course_link != '') {
                if(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm.test(this.course_link)) {
                  
                }
                else {
                  alert("Please enter a valid course link");
                  vflag = 0;
                  return false;
                }
              }
              if(this.image == '') {
                alert("Please upload Image");
                vflag = 0;
                return false;
              }
              else if(this.$refs.image_file.files[0].size > 2000000) {
                  alert("Image size should be of 2 MB only");
                  vflag = 0;
                  return false;
              }
              else {
                if((this.$refs.image_file.files[0].type != 'image/jpeg') && (this.$refs.image_file.files[0].type != 'image/jpg') && (this.$refs.image_file.files[0].type != 'image/png') && (this.$refs.image_file.files[0].type != 'image/gif')) {
                  alert("Image should be of jpeg, jpg, png, gif formats only");
                  vflag = 0;
                  return false;
                  }
              }
              return vflag;
            },
            createCourse() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                var vflag = this.doValidate();
                if(vflag == 1) {
                  axios('/external-courses',
                     {
                       method: 'POST',
                       data:
                        {
                          course_name: this.course_name,
                          course_organization: this.course_organization,
                          course_link: this.course_link,
                          affiliate_selected: this.affiliate,
                          image: this.image,
                        },
                     }
                   )
                  .then((resp) => {
                      this.course_name = '';
                      this.course_organization = '';
                      this.course_link = '';
                      this.image = '';
                      this.affiliate = [];
                      this.isAddCourseModalVisible = false;
                      this.fetchCourseListitems();
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });
                }
                }
              })
              .catch(() => {

              });
            },
            updateCourseStatus(id, status_text) {
              this.showOverlay = true;
              axios('/external-courses/' + id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchCourseListitems();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
           },
           deactivateCourseConfirm(id, tasklist_name) {
                   this.isDeactivateModalVisible = true;
                   this.deactivateId = id;
           },
           deactivateCourse(id) {
             this.isDeactivateModalVisible = false;
             this.showOverlay = true;
             axios('/external-courses/' + id,
              {
                method: 'PATCH',
                data: { "status": 'DEACTIVATED'},
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               this.fetchCourseListitems();
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
          },
           deleteCourseConfirm: function(id) {
             this.isDeleteModalVisible = true;
             this.id = id;
           },
           deleteCourse: function(id) {
             this.isDeleteModalVisible = false;
             this.showOverlay = true;
             axios('/external-courses/' + id,
                {
                  method: 'DELETE',
                }
              )
             .then((resp) => {
                 this.showOverlay = false;
                 this.fetchCourseListitems();
              })
             .catch(error => {

             });
           },
          hideActionMenu(e) {
             var matches = document.getElementsByClassName('dropdown-content');
             for (var i=0; i<matches.length; i++) {
               var container = document.getElementById('dropdown-container'+ i);

               if (!container.contains(e.target)) {
                    if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                       document.getElementById('actionDropdown' + i).classList.remove('show');
                    }
               }
             }
           },
        toggleDropdown (id) {
            document.getElementById(id).classList.toggle("show");
        },
        fetchCourseListitems() {
            this.loading = true;

            const params = { };
              if (this.search_keyword) {
                params.name = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_affiliate) {
                params.affiliate = this.search_affiliate
              }
              this.course_lists = [];
            axios.get('/manage-course', {
                params: params
            })
            .then((resp) => {
                this.loading = false;
                this.course_lists = resp.data;
                this.currentPage = 1;
                this.rows = 10;
            })
            .catch(error => {

            });
        },
        fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', text: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
                 var affiliate_option = {value: '', text: 'Filter Course Affiliate'};
                 this.affiliate_options_search.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options_search.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

        },
        manageCourse(courseId, courseName) {
            this.course_selected = courseId;
            this.courseTitle = courseName;
            axios.get('/course-affiliate-roles/' + this.course_selected)
              .then((resp) => {                  
                  this.roles_selected = resp.data.roles_assigned;
                  this.affiliate_selected = resp.data.affiliate_assigned;
               })
              .catch(error => {

              });
  
            this.isModalVisible = true; 
            verrors.clear();
        },
        saveCourseAffiliates: function() {            
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/course/assign-affiliate',
                     {
                       method: 'POST',
                       data:
                        {
                          course_id: this.course_selected,
                          affiliate_selected: this.affiliate_selected,
                          roles_selected: this.roles_selected,
                        },
                     }
                   )
                  .then((resp) => {                      
                      this.affiliate_selected = [];
                      this.roles_selected = [];
                      this.isModalVisible = false;
                      this.$emit('close');        
                      this.fetchCourseListitems();              
                      //router.push("/assessment-add-section/" + resp.data);
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
        },
    },
     mounted() {
        document.addEventListener('click', this.hideActionMenu);
     },
     beforeDestroy() {
        document.removeEventListener('click', this.hideActionMenu);
     },
    created() {
        this.fetchCourseListitems();
        this.fetchAffiliateOptions();
        document.body.className = 'naicslist-page';
    },
}
</script>
<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 25px;
  color: #FFF;
  padding: 3px 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.input-height-30 {
  line-height: 30px;
}
.naics-code-wrapper {
  padding-left: 15px;
}
hr {
  border-top: 2px solid #8b8b8b;
  margin: 0px;
}
.tasklist-row:nth-of-type(odd) {
  background-color:#fff;
}
.tasklist-row:nth-of-type(even) {
  background-color:#e9e9e9;
}
.search-wrapper {
  background-color: transparent;
}
.heading-seperator {
  border-bottom: 2px solid #00ACEE;
}
.btn-blue {
  background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
}
.heading {
  font-size: 15px;
}
.tasklist-item {
  padding: 8px 0px 8px 0px;
}
.package-name {
  padding-left: 20px;
}
#manage-link {
  color: #00ACEE;
  text-decoration: underline; 
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
 }

#affliate-wrapper .multiselect {
  border: 1px solid #767676;
  width: 99.33%;
}
#affliate-wrapper .multiselect__tags {
  padding: 8px 40px 0 15px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
.modal-header h3 {
  color: #002F42;
  font-size: 16px;
  font-weight: bold;
}
.modal-header .sub-heading {
  margin-left: 5px;
}
/* Upload Form CSS Start */
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 120px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.dropbox .input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 120px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 20px 0;
}
/* Upload Form CSS End */
.courselists #affliate-wrapper .multiselect__tags {
  border: 0;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/course_list.vue